import { render, staticRenderFns } from "./ClienteDashboardVendas.vue?vue&type=template&id=4f83fe36&scoped=true"
import script from "./ClienteDashboardVendas.vue?vue&type=script&lang=js"
export * from "./ClienteDashboardVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83fe36",
  null
  
)

export default component.exports